"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simplerestclients_1 = require("simplerestclients");
const LoggerHelper_1 = require("../helpers/LoggerHelper");
const unwrap = (resp) => resp.body;
class BaseRestClient extends simplerestclients_1.GenericRestClient {
    constructor() {
        super(...arguments);
        this._defaultOptions = {
            contentType: 'application/json',
            acceptType: 'application/json',
        };
        this.networkCallback = (startTime, options) => {
            const eventProperties = options && options.eventProperties;
            const genericEventPath = eventProperties && eventProperties.genericEventPath;
            const customPropertiesProvider = eventProperties && eventProperties.customPropertiesProvider;
            const eventPriority = eventProperties && eventProperties.priority;
            return (response) => {
                const endTime = new Date().getTime();
                const responseUrl = genericEventPath ? this._endpointUrl + genericEventPath : response.url;
                const eventUrl = responseUrl ? responseUrl.split('?', 1).join('') : responseUrl;
                const path = eventUrl ? eventUrl.replace(this._endpointUrl, '') : eventUrl;
                LoggerHelper_1.logger.network({
                    method: response.method,
                    responseTime: endTime - startTime,
                    statusCode: response.statusCode,
                    statusText: response.statusText,
                    url: eventUrl,
                    host: this._endpointUrl,
                    path,
                    custom: customPropertiesProvider ? customPropertiesProvider(response) : undefined,
                }, eventPriority);
            };
        };
    }
    performApiGet(apiPath, options) {
        return this.performApiGetDetailed(apiPath, options).then(unwrap);
    }
    performApiGetDetailed(apiPath, options) {
        const startTime = new Date().getTime();
        const promise = super.performApiGetDetailed(apiPath, options);
        promise.then(this.networkCallback(startTime, options), this.networkCallback(startTime, options));
        return promise;
    }
    performApiPost(apiPath, objToPost, options) {
        return this.performApiPostDetailed(apiPath, objToPost, options).then(unwrap);
    }
    performApiPostDetailed(apiPath, objToPost, options) {
        const startTime = new Date().getTime();
        const promise = super.performApiPostDetailed(apiPath, objToPost, options);
        promise.then(this.networkCallback(startTime, options), this.networkCallback(startTime, options));
        return promise;
    }
    performApiPatch(apiPath, objToPatch, options) {
        return this.performApiPatchDetailed(apiPath, objToPatch, options).then(unwrap);
    }
    performApiPatchDetailed(apiPath, objToPatch, options) {
        const startTime = new Date().getTime();
        const promise = super.performApiPatchDetailed(apiPath, objToPatch, options);
        promise.then(this.networkCallback(startTime, options), this.networkCallback(startTime, options));
        return promise;
    }
    performApiPut(apiPath, objToPut, options) {
        return this.performApiPutDetailed(apiPath, objToPut, options).then(unwrap);
    }
    performApiPutDetailed(apiPath, objToPut, options) {
        const startTime = new Date().getTime();
        const promise = super.performApiPutDetailed(apiPath, objToPut, options);
        promise.then(this.networkCallback(startTime, options), this.networkCallback(startTime, options));
        return promise;
    }
    performApiDelete(apiPath, objToDelete, options) {
        return this.performApiDeleteDetailed(apiPath, objToDelete, options).then(unwrap);
    }
    performApiDeleteDetailed(apiPath, objToDelete, options) {
        const startTime = new Date().getTime();
        const promise = super.performApiDeleteDetailed(apiPath, objToDelete, options);
        promise.then(this.networkCallback(startTime, options), this.networkCallback(startTime, options));
        return promise;
    }
}
exports.BaseRestClient = BaseRestClient;
